import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector, GridToolbarExport,
  GridToolbarFilterButton, GridToolbarQuickFilter
} from "@mui/x-data-grid";
import Typography from "@mui/material/Typography";
import React from "react";

export function CustomToolbar(tableName) {
  return (
    <GridToolbarContainer title={tableName} sx={{ justifyContent: 'flex-start' }}>
      <Typography variant="h6">{tableName}</Typography>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      <GridToolbarExport />
      <GridToolbarQuickFilter />
    </GridToolbarContainer>
  );
}
